import React from 'react';
import { FormattedMessage } from 'react-intl';
import { USPS_PICKUP_VIEW_ID } from './view-id-constants';

export const Pickup = {
  label: <FormattedMessage defaultMessage='Manual USPS Pickups' description='shippingPage.nav.pickup-manual' id='1q+V6j' />,
  id: USPS_PICKUP_VIEW_ID,
};
